__turbopack_context__.v({
  "inclFeesAndShippingText": "styles-module__yXwEGq__inclFeesAndShippingText",
  "includingFeesText": "styles-module__yXwEGq__includingFeesText",
  "infoIconButton": "styles-module__yXwEGq__infoIconButton",
  "originalPrice": "styles-module__yXwEGq__originalPrice",
  "originalPriceStrikethrough": "styles-module__yXwEGq__originalPriceStrikethrough",
  "priceWithFeeWrapper": "styles-module__yXwEGq__priceWithFeeWrapper",
});
